import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

/**
 * Slide 2 of the original PPTX — the legal disclaimer.
 *
 * Presented as a standalone, vertically-centred colophon page.
 * The former QR-code has moved to its own dedicated `SectionBroschure`
 * that precedes this slide.
 *
 * Certification logos (GIA, DMCC, SIRA, Kayrouz) are displayed here at
 * a large size — moved from the removed final footer section.
 */
const CERT_LOGOS = [
  { src: '/brand/gia-certification-logo.png', alt: 'GIA — Gemological Institute of America' },
  { src: '/brand/dmcc-certification-logo.png', alt: 'DMCC — Dubai Multi Commodities Centre' },
  { src: '/brand/sira-certification-logo.png', alt: 'SIRA — Security Industry Regulatory Agency' },
  { src: '/brand/kayrouz-associates-logo.png', alt: 'Kayrouz & Associates' },
];

export default function SectionDisclaimer() {
  const { t } = useT();
  const d = t.disclaimer;

  return (
    <SectionShell id="disclaimer" fullBleed data-testid="section-disclaimer">
      <div className="disclaimer-shell">
        <div className="disclaimer-inner">
          <Reveal>
            <div className="overline mb-6 text-center">{d.overline}</div>
            <h2 className="disclaimer-title font-display">
              {d.title}
            </h2>
          </Reveal>

          <Reveal delay={180}>
            <div className="disclaimer-body">
              {d.paragraphs.map((p, i) => (
                <p
                  key={i}
                  data-testid={`disclaimer-p-${i}`}
                  className={`disclaimer-p font-ui${i === 1 ? ' disclaimer-p--accent' : ''}`}
                >
                  {p}
                </p>
              ))}
            </div>
          </Reveal>

          <Reveal delay={340}>
            <div className="disclaimer-logos" data-testid="disclaimer-logos">
              {CERT_LOGOS.map((it) => (
                <img
                  key={it.alt}
                  src={it.src}
                  alt={it.alt}
                  className="disclaimer-logo"
                  loading="lazy"
                  draggable={false}
                />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </SectionShell>
  );
}
